<template>
  <mm-form
    ref="changeBillForm"
    :data="form"
    :rules="formRules"
    layout="vertical"
  >
    <mm-form-field
      label="发票类型"
      field="invoice_type"
      :required="true"
    >
      <mm-select
        v-model="form.invoice_type"
        :options="INVOICE_TYPE_OPTIONS"
        placeholder="请选择发票类型"
      />
    </mm-form-field>

    <mm-form-field label="发票抬头">
      <mm-input
        :value="displayInfo.company_name"
        disabled
        placeholder="发票抬头"
      />
    </mm-form-field>

    <mm-form-field label="发票税号">
      <mm-input
        :value="displayInfo.taxpayer_id"
        disabled
        placeholder="发票税号"
      />
    </mm-form-field>
  </mm-form>
</template>

<script>
import { INVOICE_TYPE_OPTIONS } from "../constants";

export default {
  name: "ChangeBillTypeForm",
  props: {
    form: {
      type: Object,
      required: true,
    },
    displayInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      INVOICE_TYPE_OPTIONS,
      formRules: {
        invoice_type: [{ required: true, message: "请选择发票类型" }],
      },
    };
  },
  methods: {
    validate() {
      return this.$refs.changeBillForm.validate();
    },
  },
};
</script>
